module.exports = __webpack_public_path__ + "3e3e543cbfe1bb40d2405bb3ae194d9c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-4-s.png
// module id = 2706
// module chunks = 0